import React from 'react';

const TeamSelector = ({ teams, handleTeamUpdate, selectedTeamId }) => {
    const handleTeamSelection = (e) => {
        handleTeamUpdate({ teamId: e.target.value });
    }

    return (
        <div className="list-group">
            {teams.map((teamName, index) => (
                <div key={teamName}>
                    <button 
                        className={`list-group-item list-group-item-action ${Number(selectedTeamId) === index ? 'active' : ''}`} 
                        key={index} 
                        value={index} 
                        onClick={handleTeamSelection}
                        >{teamName}
                    </button>
                </div>
            ))}
        </div>
    );
};


export default TeamSelector;
